module.exports = __webpack_public_path__ + "img/loader-wheel.e1053712.svg";